import { pageLevelLocalization } from '@/constant/localization';

import { ProcessedTourStep, TourStep } from './types';

type ProductLocalization = typeof pageLevelLocalization.product;

// Builds the driver.js step config (popover title/description/buttons) for each processed
// step. Kept separate from useTour's orchestration effect since it's a pure mapping from
// (processedSteps, steps, localization) to driver.js's step shape.
export function buildDriverSteps(
  processedSteps: ProcessedTourStep[],
  steps: TourStep[],
  productLocalization: ProductLocalization,
) {
  return processedSteps.map((s, index) => {
    const isLastStep = index === processedSteps.length - 1;
    // Get original step data to ensure we have correct icon/title even if steps were filtered
    const originalStep = steps[s.originalIndex];
    const iconData = originalStep?.icon || s.icon;
    const titleText = originalStep?.title || s.title;

    // Add tab-specific class for styling hook
    const popoverClass = originalStep.tabId ? 'driver-popover-tab-element' : '';

    // Handle icon - can be string URL or object with url/id
    let iconUrl = '';
    if (typeof iconData === 'string') {
      iconUrl = iconData;
    } else if (iconData && typeof iconData === 'object') {
      // If it's an object, try to get URL from common properties
      iconUrl = iconData.url || (iconData.id ? `/api/files/${iconData.id}` : '');
    }

    const titleContent = iconUrl
      ? `<div style="display: flex; align-items: center; gap: 8px;"><div style="width: 28px; height: 28px; background-color: #FFAE11; border-radius: 4px; display: flex; align-items: center; justify-content: center; flex-shrink: 0; overflow: hidden;"><img src="${iconUrl}" alt="" style="width: calc(100% - 4px); height: calc(100% - 4px); object-fit: contain; padding: 2px; display: block;" /></div>${titleText ? `<span>${titleText}</span>` : ''}</div>`
      : titleText || '';

    const nextBtn = `
  <div style="display:flex; align-items:center; gap:3px;">
    ${productLocalization.next}
    <svg width="8" height="10" viewBox="0 0 3 5" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2.25 4.25L0.25 2.25L2.25 0.25" stroke="currentColor" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
  </div>
`;

    return {
      element: s.element,
      popover: {
        className: popoverClass,
        title: titleContent,
        description: s.description,
        position: s.position || 'auto',
        side: s.position || 'auto',
        align: 'start',
        offset: s.position === 'right' ? 'auto' : 10,
        nextBtnText: nextBtn,
        prevBtnText: productLocalization.previous,
        doneBtnText: productLocalization.youCanBuyTheProductNow,
        closeBtnText: productLocalization.iUnderstand,
        onPopoverRender: (popover: any) => {
          try {
            const wrapper = popover.wrapper as HTMLElement;

            const isMobile = window.innerWidth <= 768;
            const originalStep = steps[s.originalIndex];

            if (isMobile && !originalStep?.tabId) {
              wrapper.classList.add('tour-popover');
            } else {
              wrapper.classList.remove('tour-popover');
            }
          } catch {}
          setTimeout(() => {
            try {
              const nextBtn = popover.wrapper.querySelector('.driver-popover-next-btn');
              const prevBtn = popover.wrapper.querySelector('.driver-popover-prev-btn');
              const closeBtn = popover.wrapper.querySelector('.driver-popover-close-btn');
              const popoverTitle = popover.wrapper.querySelector('.driver-popover-title');
              const popoverDescription = popover.wrapper.querySelector(
                '.driver-popover-description',
              );

              if (popoverTitle && popoverDescription && popoverTitle.parentNode) {
                const wrapper = document.createElement('div');
                wrapper.style.background =
                  'linear-gradient(180deg, #FFF5E6 10%, rgba(255, 182, 22, 0) 100%)';
                wrapper.style.padding = '5px';
                wrapper.style.margin = '0';
                wrapper.style.borderRadius = '8px';
                popoverTitle.style.margin = '0';
                popoverTitle.style.padding = '0';
                popoverTitle.style.marginBottom = '10px';
                popoverDescription.style.margin = '0';
                popoverDescription.style.padding = '0';
                popoverTitle.parentNode.insertBefore(wrapper, popoverTitle);
                wrapper.appendChild(popoverTitle);
                wrapper.appendChild(popoverDescription);
              }

              if (nextBtn) {
                nextBtn.id = 'tour-next-btn';
                if (isLastStep) {
                  nextBtn.textContent = productLocalization.youCanBuyTheProductNow;
                  nextBtn.id = 'tour-done-btn';
                }
              }
              const isFirstStep = index === 0;

              if (prevBtn) {
                prevBtn.id = 'tour-prev-btn';
                if (isFirstStep) {
                  prevBtn.style.display = 'none';
                } else {
                  prevBtn.style.display = '';
                }
              }
              if (closeBtn) {
                closeBtn.id = 'tour-close-btn';
                closeBtn.textContent = productLocalization.iUnderstand;
                closeBtn.setAttribute('aria-label', productLocalization.iUnderstand);
              }
            } catch {}
          }, 0);
        },
      } as any,
    };
  });
}
